module.exports = __webpack_public_path__ + "static/media/mountains-big.96b3c396.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mountains-big.jpg
// module id = 81
// module chunks = 3